import { useAppStoreActions } from "@/hooks/store/useApp";

export const useLoadingOverlay = () => {
  const { setLoading: _setLoading, loading, loadingText: text } = useAppStoreActions();
  const setLoading = (...state) => _setLoading(...state);
  return { loading, text, setLoading };
};
